export default {
  navItems: [
    { link: '/', intlId: 'pages.home' },
    { link: '/process', intlId: 'pages.process' },
    { link: '/apply', intlId: 'pages.apply' },
    { link: '/contact', intlId: 'pages.contact' },
  ],
};
